<template>
  <div class="text-right" v-if="allow_user_inference">
    <b-button size="sm" class="user-cta__action has-icon" variant="light"
              :disabled="checking"
              @click="onClick">
      <Icon name="magicWand" width="22"/>
      {{ $t('modal_face_inference.cta') }}
    </b-button>
  </div>
</template>


<script>
import EventService from "@/services/Event.js"
import {mapGetters} from "vuex";

// reason restituito da getFaceInferenceStatus -> chiave di traduzione del messaggio
const REASON_MESSAGES = {
  rate_limit_exceeded: 'rate_limit_message',
  feature_not_enabled: 'feature_not_enabled_message',
  checkin_not_master: 'checkin_not_master_message',
  no_selfie: 'no_selfie_message',
  no_media: 'no_media_message',
  no_new_media: 'no_media_message',
  uploads_not_completed: 'uploads_not_completed_message'
}

export default {
  name: 'FaceInferenceCta',

  props: {
    checkinId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      checking: false
    }
  },

  computed: {
    ...mapGetters('checkinDetail', ['allow_user_inference'])
  },

  methods: {
    async onClick() {
      this.checking = true
      try {
        const response = await EventService.getFaceInferenceStatus(this.checkinId)
        const data = response.data || {}

        if (data.enabled) {
          this.$bvModal.show('modal-face-inference')
        } else {
          const messageKey = REASON_MESSAGES[data.reason] || 'not_available_message'
          this.$bvToast.toast(this.$t(`modal_face_inference.${messageKey}`), {
            title: this.$t('modal_face_inference.cta'),
            variant: 'warning',
            autoHideDelay: 5000
          })
        }
      } catch (error) {
        console.error('Error checking face inference status:', error)
        this.$bvToast.toast(this.$t('modal_face_inference.not_available_message'), {
          title: this.$t('modal_face_inference.cta'),
          variant: 'warning',
          autoHideDelay: 5000
        })
      } finally {
        this.checking = false
      }
    }
  }
}
</script>
